export function validCrmNumberUf(crm: string): boolean {
  const pattern = /^([0-9]{0,7})[\s\-\\\/]?([a-zA-z]{2})$/;
  if (!crm) {
    return false;
  }
  return pattern.test(crm);
}
